import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { page } from '../class/status';
import { DateRange } from '../class/dateRange';
import * as moment from 'moment';
import { Rtable } from '../class/rtabledata';
import { menulist }  from '../class/status';

@Component({
  selector: 'app-masssending',
  templateUrl: './masssending.component.html',
  styleUrls: ['./masssending.component.css']
})
export class MassSendingComponent implements OnInit {
  @ViewChild('closeModal') closeModal: any

  zeroFormGroup = this.formBuilder.group({
    zeroCtrl: ['', Validators.required],
  });
  firstFormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this.formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  isEditable = true;

  dateRange = new DateRange(new Date(2021, 1, 1), new Date(2022, 1, 1));

  today:any = '2022-10-15';
  selected: any = { startDate: moment().add(1, 'days'), endDate: moment().add(1, 'days') };
  secondDateRange:string = '';
  rightFieldOptions: any =  {
    startDate: moment().add(-5, 'days'),
    endDate:moment().add(20, 'days'),
    minDate: moment().add(-5, 'days'),
    maxDate:moment().add(20, 'days'),
    preDefinedRanges: [
      {
        name: 'range1',
        value: {
          start: moment().add(1, 'days'),
          end: moment().add(10, 'days')
        }
      },
    ]
  }
  selectedDateTime: string;

  onRangeSelected(value: any) {
    console.log(value);
    console.log(moment().add(10, 'days'));
  }
  loading:boolean=true;

  dtOptions: DataTables.Settings = {
    // searching: false, 
    // paging: false, 
    // info: false,
    // serverSide: true,
    // ajax:"https://chatmate.tw/admin/get_statistics.php"
    // order:[[0, 'desc']],
    // ajax: this.callback
  };
  posts:any=[];
  form: FormGroup = null;
  posts_title:any=[];
  posts_content:any=[];
  posts_type:any=[];
  posts_input:any=[];
  edit_data:any=[];
  posts_attributes:any=[];
  upload_pic:any;
  upload_voice:any;
  upload_voice_filename:any;
  upload_video:any;
  upload_video_filename:any;
  selected_girl:any=[];
  last_post:any;
  execution = '0';

  init_attributes(){
    let tmp_data = {};
    Rtable.structure.type = 'txt';
      tmp_data = {
        start_time:{name:'開始時間'},
        end_time:{name:'結束時間'},
        amount:{name:'應送數量'},
        name:{name:'女生身份'},
        setting:{name:'男生設定', type:'opt'},
        content:{name:'訊息內容'},
        pic:{name:'圖片', type:'img',type_cls_dk:'width50px'},
        media:{name:'語音', type:'opt'},
        video:{name:'影片', type:'opt'},
        push_enable_rate:{name:'推播開啟率', type:'num', unit:'%'},
        push_click_rate:{name:'推播點擊率', type:'num', unit:'%'},
        read_rate:{name:'讀訊率', type:'num', unit:'%'},
        response_rate:{name:'回訊率', type:'num', unit:'%'},
        //chat_rate:{name:'視訊率', type:'num', unit:'%'},
        deposit_rate:{name:'儲值率', type:'num', unit:'%'},
        status_name:{name:'狀態'},
      }
    this.posts_attributes = Rtable.init(tmp_data);
  }

  constructor(public httpClient: HttpClient, private formBuilder: FormBuilder,) {
    this.selected2 = {
      startDate: moment().subtract(4, 'days').startOf('day'),
      endDate: moment().subtract(1, 'days').startOf('day')
    };
    const currentDate = new Date();
    this.selectedDateTime = this.formatDateTime(currentDate);
  }
  trackByFn(i: number, item: any): any { return item ? (item.id ?? item.user_id ?? i) : i; }

  ngOnInit(): void {
    this.form = this.formBuilder.group({});

    this.selected.startDate = moment().subtract(4, 'days').startOf('day');
    this.selected.endDate = moment().subtract(1, 'days').startOf('day');

    console.log(this.rightFieldOptions);
    this.posts = [
      // {
      //   create_dt:1,
      //   total_amount:'aa',
      //   amount_per_person:'aa',
      //   setting:'aa',
      //   message:'aa',
      //   media:'aa',
      //   current_amount:'aa',
      //   push_click_rate:'aa',
      //   read_rate:'aa',
      //   response_rate:'aa',
      //   chat_rate:'aa',
      //   deposit_rate:'AA'
      // },
    ]

    this.init_attributes();

    this.init_mass_sending_list();

    this.init_girl_list();

  }
  sort_obj:any = {column:'create_dt',sort:'0'}
  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  init_mass_sending_list(){
    this.loading = true;

    const body = {page: this.pageobj.page,count:this.pageobj.count,
      action:1,
     
    };
    this.httpClient.post<any>("/get_masssending.php",body).subscribe(res => {
      if(res.status){ 
            this.loading = false;
          this.last_post = res.data[0];
          this.posts = res.data;
          this.pageobj.total_count = res.total_count;
          this.posts_input = {
            attribute:this.posts_attributes,
            content:this.posts,
          }
      }else{
        
      }

      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
    });
  }

  search_gender:string = '2';
  search_country:string = '-1';
  search_model:string = '';
  now:string = '0';
  girl_pageobj:page = {page:0,count:3,total_count:0};
  girl_pageobjstr:string=JSON.parse(JSON.stringify(this.girl_pageobj))
  girl_data:any[] = [];

  init_girl_list(){
    console.log('init_girl_list', this.search_model);

    const body = {page: this.girl_pageobj.page,count:this.girl_pageobj.count,
    search:this.search_model,
    sort_obj:this.sort_obj,
    country:this.search_country,
    gender:this.search_gender,
    action:this.now
    };
    this.httpClient.post<any>("/get_behavor_list.php",body).subscribe(res => {
      if(res.status){
          this.girl_data = res.data;
          this.girl_pageobj.total_count = res.total_count
      }else{
        this.girl_pageobj.total_count = 0
      }
      this.girl_pageobjstr=JSON.parse(JSON.stringify(this.girl_pageobj))
      console.log('res',res);
    });
  }

  search_boy_gender:string = '1';
  search_boy_country:string = '-1';
  search_boy_model:string = '';
  search_boy_except_model:string = '';
  boy_pageobj:page = {page:0,count:10,total_count:0};
  boy_pageobjstr:string=JSON.parse(JSON.stringify(this.boy_pageobj))
  boy_data:any[] = [];
  boy_data_tmp:any[] = [];
  search_boy_list = '';

  execution_option:menulist=[
    { "id": '0', "name": "媒體+文字" }, 
    { "id": '1', "name": "文字+媒體" }
  ];

  country_option: any[] = [
    { "id": '-1', "name": "全部國家" }, 
    { "id": '886', "name": "台灣" }
  ];
  push_option: any[] = [
    { "id": '1', "name": "是" }, 
    { "id": '0', "name": "否" },
    { "id": '-1', "name": "不限" }
  ];
  register_option: any[] = [
    { "id": '0', "name": "1天內" }, 
    { "id": '1', "name": "1天以上~1週" },
    { "id": '2', "name": "1週以上~1個月" },
    { "id": '3', "name": "1個月以上~3個月" },
    { "id": '4', "name": "3個月以上~半年" },
    { "id": '-1', "name": "不限" }
  ];
  deposit_option: any[] = [
    { "id": '0', "name": "否" },
    { "id": '1', "name": "是" },
    { "id": '-1', "name": "不限" }
  ];
  chat_option: any[] = [
    { "id": '0', "name": "否" },
    { "id": '1', "name": "是" },
    { "id": '-1', "name": "不限" }
  ];
  chatdate_option: any[] = [
    { "id": '0', "name": "1天內" }, 
    { "id": '1', "name": "1天以上~1週" },
    { "id": '2', "name": "1週以上~1個月" },
    { "id": '3', "name": "1個月以上~3個月" },
    { "id": '-1', "name": "不限" }
  ];
  login_option: any[] = [
    { "id": '0', "name": "1天內" }, 
    { "id": '1', "name": "1天以上~1週" },
    { "id": '2', "name": "1週以上~1個月" },
    { "id": '3', "name": "1個月以上~3個月" },
    { "id": '-1', "name": "不限(3個月內)" }
  ];
  sending_option: any[] = [
    { "id": '0', "name": "1天內" }, 
    { "id": '1', "name": "3天內" },
    { "id": '2', "name": "1週內" },
    { "id": '3', "name": "1個月內" },
    { "id": '-1', "name": "不限" }
  ];
  
  search_boy_enable_push_msg = '1';
  search_boy_register = '-1';
  search_boy_has_deposit = '-1';
  search_boy_has_chat = '-1';
  search_boy_last_chat = '0';
  search_boy_last_login = '-1';
  search_boy_has_mass_send = '-1';
  search_boy_has_chat_the_girl = '-1';
  selected_boy = 0;
  block_count = 0;
  expand_boy_list = false;
  msg_content = '';
  msg_amount = '';
  img_diamond = '';
  video_diamond = '';
  init_boy_list(only_update_tmp = false){
    console.log('init_boy_list', this.search_boy_model);

    const body = {page: this.boy_pageobj.page,count:this.boy_pageobj.count,
    search:only_update_tmp?this.search_boy_list:this.search_boy_model,
    search_except:this.search_boy_except_model,
    sort_obj:this.sort_obj,
    country:this.search_boy_country,
    gender:this.search_boy_gender,
    action:this.now,
    search_boy_enable_push_msg:this.search_boy_enable_push_msg,
    search_boy_register:this.search_boy_register,
    search_boy_has_deposit:this.search_boy_has_deposit,
    search_boy_has_chat:this.search_boy_has_chat,
    search_boy_last_chat:this.search_boy_last_chat,
    search_boy_last_login:this.search_boy_last_login,
    search_boy_has_mass_send:this.search_boy_has_mass_send,
    search_boy_has_chat_the_girl:this.search_boy_has_chat_the_girl,
    selected_girl: this.selected_girl
    };
    this.httpClient.post<any>("/get_masssending.php",body).subscribe(res => {

      if(res.status){
        console.log('boy',res.total_count);

          if(only_update_tmp == false){
            this.boy_data = res.data;
            this.selected_boy = res.total_count;
            this.msg_amount = res.total_count;
            this.block_count = res.block_count;
          }

          this.boy_data_tmp = res.data;

          this.boy_pageobj.total_count = res.total_count;

      }else{
        
      }

      this.boy_pageobjstr=JSON.parse(JSON.stringify(this.boy_pageobj))
      console.log('res',res);
    });
  }

  girlrowclick(item:any){
    console.log(item);
    delete item['login'];
    delete item['ip_and_os'];
    delete item['regist_info'];
    delete item['follower_list'];
    delete item['login2'];
    this.selected_girl = item;
  }

  selectionChange(value: any){
    console.log(value);
    if(value.selectedIndex == 2 && value.previouslySelectedIndex == 1){
      this.init_boy_list();
    }
  }

  upload(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.upload_pic = e.target.result;

      });
    }
  }
  upload2(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.upload_voice = e.target.result;
        this.upload_voice_filename = file.name;
        if(this.msg_content == ''){
            this.msg_content = "您有未讀語音訊息";
        }
        // this.upload_video = '';
        // this.upload_video_filename = '';
      });
    }
  }
  upload3(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.upload_video = e.target.result;
        this.upload_video_filename = file.name;
        if(this.msg_content == ''){
            this.msg_content = "您有未讀影片訊息";
        }

        // this.upload_voice = '';
        // this.upload_voice_filename = '';
      });
    }
  }
  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_mass_sending_list();
    }
  }
  callback1(pageobj:page){
    if(JSON.stringify(this.girl_pageobj)!=JSON.stringify(pageobj)){
      this.girl_pageobj = pageobj;
      this.init_girl_list();
    }
  }
  callback2(pageobj:page){
    if(JSON.stringify(this.boy_pageobj)!=JSON.stringify(pageobj)){
      this.boy_pageobj = pageobj;
      this.init_boy_list();
    }
  }

  set_mass_sending(){
    this.loading = true;
    const now = new Date();
    // 設定特定時間（例如 2023-11-16 11:40:22）
    const specificTime = new Date(this.last_post.start_time);
    console.log(this.last_post.start_time)
    // 計算兩個時間的差異（以毫秒為單位）
    const timeDifference = now.getTime() - specificTime.getTime();
    // 轉換為分鐘
    const timeDifferenceInMinutes = timeDifference / (1000 * 60);
    console.log(now, specificTime, timeDifference)
    // 檢查是否小於10分鐘
    // 改成預約制，後端判斷
    // if (timeDifferenceInMinutes < 10) {
    //     alert("離前一個群發訊息必須至少相隔 10 分鐘。");
    //     return;
    // }

    console.log('init_boy_list', this.search_boy_model);
    //this.loading = true;
    const boy_setting = {page: 0,count:this.msg_amount,
      search:this.search_boy_model,
      search_except:this.search_boy_except_model,
      sort_obj:this.sort_obj,
      country:this.search_boy_country,
      gender:this.search_boy_gender,
      action:this.now,
      search_boy_enable_push_msg:this.search_boy_enable_push_msg,
      search_boy_register:this.search_boy_register,
      search_boy_has_deposit:this.search_boy_has_deposit,
      search_boy_has_chat:this.search_boy_has_chat,
      search_boy_last_chat:this.search_boy_last_chat,
      search_boy_last_login:this.search_boy_last_login,
      search_boy_has_mass_send:this.search_boy_has_mass_send,
      search_boy_has_chat_the_girl:this.search_boy_has_chat_the_girl,
      selected_girl: this.selected_girl,
      };

    const body = {
      boy_setting: boy_setting,
      //boy_data: this.boy_data,
      girl_data: this.selected_girl,
      msg_content:this.msg_content,
      msg_amount:this.msg_amount,
      upload_pic:this.upload_pic,
      upload_voice:this.upload_voice,
      upload_video:this.upload_video,
      selectedDateTime:this.selectedDateTime,
      img_diamond: this.img_diamond,
      video_diamond: this.video_diamond,
      execution:this.execution
    };
    this.httpClient.post<any>("/set_masssending.php",body).subscribe(res => {
        console.log('set_masssending',res);
        if(res.status == false) {
            this.loading = false;
            alert(res.message)
        }else{
            this.init_mass_sending_list();
        }
    });
    this.closeModal.nativeElement.click();
  }

  modal_action = 0;
  item_setting;
  masssending_click(){
    this.modal_action = 0;
  }
  setting_click(item:any){
    this.modal_action = 1;
    this.item_setting = JSON.parse(item);
    console.log(this.item_setting);
  }

  //https://github.com/fetrarij/ngx-daterangepicker-material
  selected2: any = { startDate: null, endDate: null };
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }

  ngModelChange(e) {
    // eslint-disable-next-line no-console
    console.log( moment(e.startDate).format('YYYY-MM-DD'),moment(e.endDate).format('YYYY-MM-DD') );

    // this.time.start =  moment(e.startDate).format('YYYY-MM-DD')
    // this.time.end =  moment(value.end).format('YYYY-MM-DD')


  }

  change(e): void {
    // eslint-disable-next-line no-console
    // console.log({ ['change()']: e });
    // console.log(e.endDate.format('YYYY-MM-DD HH:mm:ss'));
  }

  private formatDateTime(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    //return `${year}-${month}-${day}T${hours}:${minutes}`;
    return `${year}-${month}-${day} ${hours}:${minutes}:00`;
  }
}
